import { render, staticRenderFns } from "./orderPayment.vue?vue&type=template&id=a6fefe34&scoped=true&"
import script from "./orderPayment.vue?vue&type=script&lang=js&"
export * from "./orderPayment.vue?vue&type=script&lang=js&"
import style0 from "./orderPayment.vue?vue&type=style&index=0&id=a6fefe34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fefe34",
  null
  
)

export default component.exports